import accounting from '../../assets/img/Features/13 ACCOUNTING.png';
import payments from '../../assets/img/Features/14 PAYMENTS.png';

export default [
  {
    icon: ["fas", "calculator"],
    iconText: "ACCOUNTING",
    color: "danger",
    title: "Smarter Financial Management",
    description:
      "Introducing the Accounting feature of CONDOZAK™ - a simple way for Property Managers to organize financial records, track payments, and manage key financial information in one place. Stay on top of your building’s finances with less manual work and better visibility.",
    image: accounting
  },
  {
    icon: ["fas", "dollar-sign"],
    iconText: "PAYMENTS",
    color: "info",
    title: "Stay in Control",
    description:
      "With CONDOZAK™ Accounting, Property Managers can keep payment information structured, accessible, and easier to manage. From tracking payments to maintaining organized records, day-to-day financial administration becomes simpler and more efficient.",
    image: payments,
    inverse: true
  }

];
